<template>
    <div class="relative pb-8">
        <document-tabs :current_tab="activeTab" :includes_signatures="includes_docusign" @change="activeTab = $event" />
        <div v-show="activeTab === 'documents'" id="section-panel-documents" role="tabpanel" aria-labelledby="section-tab-documents">
        <div class="text-sm text-gray-600 mb-4 py-2">Choose documents from your library to add to this transaction, or upload them directly.</div>
        <div class="document-workspace grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">
            <section v-if="personal_library" class="transaction-document-panel min-w-0">
                <document-library :personal_library="sources.personal" :team_library="sources.team" :forms_library="sources.forms"
                    :storage-key="`c2c:transaction:${property.id}:library`" source-mode :add-enabled="!read_only" @add-document="addDocument" />
            </section>
            <section class="transaction-document-panel min-w-0" :class="{ 'xl:col-span-2': !personal_library }">
                <document-library ref="transaction" :personal_library="transaction_library" :storage-key="`c2c:transaction:${property.id}:documents`" transaction-mode
                    @updated="updated" @drop-document="dropDocument" />
            </section>
        </div>
        </div>
        <section v-if="includes_docusign" v-show="activeTab === 'signatures'" id="section-panel-signatures" role="tabpanel" aria-labelledby="section-tab-signatures">
            <signatures-index
                :embedded="true"
                :property="property"
                :documents="documents_proxy"
                :templates="templates_proxy"
                :document_folders="document_folders_proxy"
                :envelopes="envelopes"
                :read_only="read_only"
                :envelopes_available="envelopes_available"
                :has_active_docusign_user="has_active_docusign_user"
                :docusign_user="docusign_user"
                :prompt_for_broker_completion="prompt_for_broker_completion"
                :documents_index_route="documents_index_route"
                :signature_purchase_route="signature_purchase_route"
                :signatures_index_route="signatures_index_route"
                :signatures_create_route="signatures_create_route"
                :signatures_destroy_route="signatures_destroy_route"
            />
        </section>

    </div>
</template>

<script>
import DocumentTabs from './document-tabs.vue';
import DocumentLibrary from '../../broker/library/document-library.vue';
import SignaturesIndex from './signatures/signatures-index.vue';

export default {
    components: { DocumentTabs, DocumentLibrary, SignaturesIndex },
    props: {
        property: {},
        documents: {},
        templates: {},
        document_folders: {},
        read_only: { default: false },
        includes_docusign: { default: false },
        has_active_docusign_user: { default: false },
        docusign_event: {},
        store_route: {},
        documents_index_route: {},
        signatures_index_route: {},
        transaction_library: { required: true },
        forms_library: { default: null },
        personal_library: { default: null },
        team_library: { default: null },
        copy_from_library_route: {},
        envelopes: { default: () => [] },
        envelopes_available: {},
        docusign_user: {},
        prompt_for_broker_completion: { default: false },
        signature_purchase_route: {},
        signatures_create_route: {},
        signatures_destroy_route: {},
    },

    data() {
        return { activeTab: this.includes_docusign && window.location.hash === '#signatures' ? 'signatures' : 'documents', documents_proxy: this.documents || [], templates_proxy: this.templates || [], document_folders_proxy: this.document_folders || [] };
    },
    computed: {
        sources() {
            const adapt = (library, type) => library ? {
                ...library, can_edit: false,
                documents: library.documents.map(document => ({
                    ...document, source_type: type,
                    add_route: type === 'forms' ? document.add_route : this.copy_from_library_route.replace('LIBRARY_DOCUMENT_ID', document.id),
                })),
            } : null;
            return { personal: adapt(this.personal_library, 'personal'), team: adapt(this.team_library, 'team'), forms: adapt(this.forms_library, 'forms') };
        },
    },
    methods: {
        addDocument({ document }) { if (!this.read_only) this.$refs.transaction.addSource(document); },
        dropDocument({ id, source, folderId }) {
            const document = this.sources[source]?.documents.find(item => item.id === id);
            if (document && !this.read_only) this.$refs.transaction.addSource(document, folderId);
        },
        updated(data) {
            this.documents_proxy = data.documents;
            this.templates_proxy = data.templates;
            this.document_folders_proxy = data.document_folders;
        },
    },
};
</script>

<style scoped>
.transaction-document-panel { display: flex; flex-direction: column; height: clamp(23rem, calc(60vh - 5rem), 37rem); min-height: 0; overflow: hidden; border: 1px solid #d1d5db; border-radius: 0.5rem; background: #fff; }
</style>
